import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.column-carousel').forEach((carousel) => {
        const swiper = new Swiper(carousel, {
            modules: [Navigation, Scrollbar],

            watchOverflow: false,

            scrollbar: {
                el: carousel.querySelector('.swiper-scrollbar'),
                draggable: true,
                hide: false, 
            },
            navigation: {
                nextEl: carousel.querySelector('.swiper-button-next'),
                prevEl: carousel.querySelector('.swiper-button-prev'),
            },

            slidesPerView: 1,
            spaceBetween: 26,
            observer: true,
            observeParents: true,

            breakpoints: {
                768: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
            },
        });

        window.addEventListener('load', () => swiper.update());
    });
});
